var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('router-view',{on:{"changeLoadingOverlay":function($event){return _vm.changeLoadingOverlay($event)}}}):_c('v-overlay',[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }